// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Settings-menu plugin styles. The menu uses the shared v13 system
 * (.kt-ui-v13 + kt-section/kt-action/...); see src/engine/ui/menu-v13.css.
 * Only the filter box and the dense-form fixes (required when a card stacks
 * many labelled rows + a standalone action) live here, scoped to #settings-menu.
 */

/* ===== Filter box ===== */
.settings-filter-wrapper {
  margin: 0 6px 12px;
}

#settings-filter {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  margin: 0;
  padding: 0 12px;
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid var(--color-dark-border);
  border-radius: var(--kt-radius-md, 6px);
  color: var(--color-text-light, #f5f5f5);
  font-size: 13px;
}

#settings-filter::placeholder {
  color: var(--color-dark-text-muted);
}

#settings-filter:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 1px var(--color-primary);
}

/* ===== Dense-form fixes (recurring v13 miss) ===== */

/* Stacked select/number fields: keep the floating "active" label from striking
   through the row above. The first field after the section label only needs the
   smaller gap. */
#settings-menu .kt-section .input-field.col.s12 { margin-top: 18px; }
#settings-menu .kt-section-label + .input-field.col.s12 { margin-top: 6px; }

/* Toggle rows: tighten the Materialize .row default and give the switches a
   little consistent vertical rhythm inside the card. */
#settings-menu .kt-section .switch.row { margin-bottom: 0; margin-top: 12px; }
#settings-menu .kt-section-label + .switch.row { margin-top: 4px; }

/* Standalone "Reset to Defaults" action is a direct child of the form, so it is
   width:100% and would run 12px past the inset cards; subtract the side margins
   so its edges line up with the cards. */
#settings-form > .kt-action {
  box-sizing: border-box;
  width: calc(100% - 12px);
  margin: 8px 6px 0;
}

/* Focus indication: swap the app-wide :focus-visible outline (which overlaps the
   floating label) for KeepTrack's underline. */
#settings-menu .input-field input:focus {
  border-bottom-color: var(--color-primary) !important;
  box-shadow: 0 1px 0 0 var(--color-primary);
}
#settings-menu .input-field input:focus-visible { outline: none; }
`, "",{"version":3,"sources":["webpack://./src/plugins/settings-menu/settings-menu.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,sDAAsD;;AAEtD;;iBAEiB;AACjB,kDAAkD,gBAAgB,EAAE;AACpE,0DAA0D,eAAe,EAAE;;AAE3E;uDACuD;AACvD,yCAAyC,gBAAgB,EAAE,gBAAgB,EAAE;AAC7E,iDAAiD,eAAe,EAAE;;AAElE;;yCAEyC;AACzC;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;+CAC+C;AAC/C;EACE,oDAAoD;EACpD,0CAA0C;AAC5C;AACA,kDAAkD,aAAa,EAAE","sourcesContent":["/*\n * Settings-menu plugin styles. The menu uses the shared v13 system\n * (.kt-ui-v13 + kt-section/kt-action/...); see src/engine/ui/menu-v13.css.\n * Only the filter box and the dense-form fixes (required when a card stacks\n * many labelled rows + a standalone action) live here, scoped to #settings-menu.\n */\n\n/* ===== Filter box ===== */\n.settings-filter-wrapper {\n  margin: 0 6px 12px;\n}\n\n#settings-filter {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  margin: 0;\n  padding: 0 12px;\n  background: rgba(0, 0, 0, 0.28);\n  border: 1px solid var(--color-dark-border);\n  border-radius: var(--kt-radius-md, 6px);\n  color: var(--color-text-light, #f5f5f5);\n  font-size: 13px;\n}\n\n#settings-filter::placeholder {\n  color: var(--color-dark-text-muted);\n}\n\n#settings-filter:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 1px var(--color-primary);\n}\n\n/* ===== Dense-form fixes (recurring v13 miss) ===== */\n\n/* Stacked select/number fields: keep the floating \"active\" label from striking\n   through the row above. The first field after the section label only needs the\n   smaller gap. */\n#settings-menu .kt-section .input-field.col.s12 { margin-top: 18px; }\n#settings-menu .kt-section-label + .input-field.col.s12 { margin-top: 6px; }\n\n/* Toggle rows: tighten the Materialize .row default and give the switches a\n   little consistent vertical rhythm inside the card. */\n#settings-menu .kt-section .switch.row { margin-bottom: 0; margin-top: 12px; }\n#settings-menu .kt-section-label + .switch.row { margin-top: 4px; }\n\n/* Standalone \"Reset to Defaults\" action is a direct child of the form, so it is\n   width:100% and would run 12px past the inset cards; subtract the side margins\n   so its edges line up with the cards. */\n#settings-form > .kt-action {\n  box-sizing: border-box;\n  width: calc(100% - 12px);\n  margin: 8px 6px 0;\n}\n\n/* Focus indication: swap the app-wide :focus-visible outline (which overlaps the\n   floating label) for KeepTrack's underline. */\n#settings-menu .input-field input:focus {\n  border-bottom-color: var(--color-primary) !important;\n  box-shadow: 0 1px 0 0 var(--color-primary);\n}\n#settings-menu .input-field input:focus-visible { outline: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
